var map = {
	"./mobile-en-us/views/Copy.vue": 57989,
	"./mobile-en-us/views/DownloadList.vue": 4046,
	"./mobile-en-us/views/Famous.vue": 69341,
	"./mobile-en-us/views/FamousInfo.vue": 18749,
	"./mobile-en-us/views/Floorplan.vue": 62501,
	"./mobile-en-us/views/History.vue": 20270,
	"./mobile-en-us/views/Index.vue": 68010,
	"./mobile-en-us/views/News.vue": 94795,
	"./mobile-en-us/views/NewsInfo.vue": 59695,
	"./mobile-en-us/views/NotFound.vue": 83895,
	"./mobile-en-us/views/SinglePage.vue": 48571,
	"./mobile-en-us/views/UserChangePassword.vue": 92032,
	"./mobile-en-us/views/UserEdit.vue": 71731,
	"./mobile-en-us/views/UserExhibition.vue": 99860,
	"./mobile-en-us/views/UserForgotPassword.vue": 60553,
	"./mobile-en-us/views/UserLogin.vue": 27110,
	"./mobile-en-us/views/UserLogout.vue": 89917,
	"./mobile-en-us/views/UserRegister.vue": 45768,
	"./mobile-en-us/views/UserReserve.vue": 13629,
	"./mobile-en-us/views/UserReserveInfo.vue": 71613,
	"./mobile-en-us/views/VueCropper - 副本.vue": 86185,
	"./mobile-en-us/views/VueCropper.vue": 62485,
	"./mobile-en-us/views/upload-cropper.vue": 32281,
	"./mobile-zh-cn/views/Copy.vue": 67107,
	"./mobile-zh-cn/views/DownloadList.vue": 63168,
	"./mobile-zh-cn/views/Famous.vue": 84783,
	"./mobile-zh-cn/views/FamousInfo.vue": 97819,
	"./mobile-zh-cn/views/Floorplan.vue": 11475,
	"./mobile-zh-cn/views/History.vue": 74476,
	"./mobile-zh-cn/views/Index.vue": 33320,
	"./mobile-zh-cn/views/News.vue": 12341,
	"./mobile-zh-cn/views/NewsInfo.vue": 1413,
	"./mobile-zh-cn/views/NotFound.vue": 1825,
	"./mobile-zh-cn/views/SinglePage.vue": 52289,
	"./mobile-zh-cn/views/UserChangePassword.vue": 54838,
	"./mobile-zh-cn/views/UserEdit.vue": 21105,
	"./mobile-zh-cn/views/UserExhibition.vue": 78958,
	"./mobile-zh-cn/views/UserForgotPassword.vue": 65231,
	"./mobile-zh-cn/views/UserLogin.vue": 59452,
	"./mobile-zh-cn/views/UserLogout.vue": 88007,
	"./mobile-zh-cn/views/UserRegister.vue": 74774,
	"./mobile-zh-cn/views/UserReserve.vue": 94823,
	"./mobile-zh-cn/views/UserReserveInfo.vue": 54339,
	"./mobile-zh-cn/views/VueCropper - 副本.vue": 92179,
	"./mobile-zh-cn/views/VueCropper.vue": 68071,
	"./mobile-zh-cn/views/upload-cropper.vue": 63803,
	"./pc-en-us/views/Copy.vue": 23562,
	"./pc-en-us/views/DownloadList.vue": 62821,
	"./pc-en-us/views/Famous.vue": 96266,
	"./pc-en-us/views/FamousInfo.vue": 61846,
	"./pc-en-us/views/Floorplan.vue": 90188,
	"./pc-en-us/views/History.vue": 15899,
	"./pc-en-us/views/Index.vue": 84479,
	"./pc-en-us/views/News.vue": 53248,
	"./pc-en-us/views/NewsInfo.vue": 9056,
	"./pc-en-us/views/NotFound.vue": 94512,
	"./pc-en-us/views/SinglePage.vue": 2044,
	"./pc-en-us/views/UserChangePassword.vue": 31199,
	"./pc-en-us/views/UserEdit.vue": 19512,
	"./pc-en-us/views/UserExhibition.vue": 5015,
	"./pc-en-us/views/UserForgotPassword.vue": 61866,
	"./pc-en-us/views/UserLogin.vue": 4595,
	"./pc-en-us/views/UserLogout.vue": 32146,
	"./pc-en-us/views/UserRegister.vue": 95855,
	"./pc-en-us/views/UserReserve.vue": 44456,
	"./pc-en-us/views/UserReserveInfo.vue": 84888,
	"./pc-en-us/views/VueCropper.vue": 30990,
	"./pc-en-us/views/upload-cropper.vue": 53150,
	"./pc-zh-cn/views/Copy.vue": 77384,
	"./pc-zh-cn/views/DownloadList.vue": 19927,
	"./pc-zh-cn/views/Famous - 副本.vue": 40294,
	"./pc-zh-cn/views/Famous.vue": 18052,
	"./pc-zh-cn/views/FamousInfo.vue": 35852,
	"./pc-zh-cn/views/Floorplan.vue": 60002,
	"./pc-zh-cn/views/History.vue": 15737,
	"./pc-zh-cn/views/Index.vue": 45621,
	"./pc-zh-cn/views/News.vue": 8330,
	"./pc-zh-cn/views/NewsInfo.vue": 51510,
	"./pc-zh-cn/views/NotFound.vue": 39210,
	"./pc-zh-cn/views/SinglePage.vue": 86818,
	"./pc-zh-cn/views/UserChangePassword.vue": 26093,
	"./pc-zh-cn/views/UserEdit.vue": 71654,
	"./pc-zh-cn/views/UserExhibition.vue": 20145,
	"./pc-zh-cn/views/UserForgotPassword.vue": 60040,
	"./pc-zh-cn/views/UserLogin.vue": 90633,
	"./pc-zh-cn/views/UserLogout.vue": 2868,
	"./pc-zh-cn/views/UserRegister.vue": 72293,
	"./pc-zh-cn/views/UserReserve.vue": 95986,
	"./pc-zh-cn/views/UserReserveInfo.vue": 97902,
	"./pc-zh-cn/views/VueCropper.vue": 17064,
	"./pc-zh-cn/views/upload-cropper.vue": 65736
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 27987;
module.exports = webpackAsyncContext;